import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-chart-single-icon',
  templateUrl: 'chart-single-icon.component.html'
})
export class ChartSingleIconComponent {
  constructor() {}
}
